import { HttpClient } from '../HttpClient';
/**
 * * Put Project Logs
 */
export const PutProjectLogs = async (putData) => {
  try {
    const { data } = await HttpClient.put(`api/projectLogs`, {
      ...putData,
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
